<template>
	<core-modal
		v-if="lead"
		:name="id + '-show-lead-modal'"
		class="omapi-leadmodal__wrapper"
		header-text="Contact Details"
		:width="850"
		v-on="$listeners"
	>
		<modals-content class="omapi-multi-column flex omapi-leadmodal__content">
			<table-base
				:is-loading="false"
				:do-select-all="false"
				:widefat="false"
				class="omapi-table omapi-multi-column__primary omapi-leadmodal__details"
			>
				<table-row>
					<th>First Name</th>
					<table-cell>
						<template v-if="firstName">{{ firstName }}</template>
						<em v-else>Unknown</em>
					</table-cell>
				</table-row>
				<table-row>
					<th>Last Name</th>
					<table-cell>
						<template v-if="lastName">{{ lastName }}</template>
						<em v-else>Unknown</em>
					</table-cell>
				</table-row>
				<table-row>
					<th>Email</th>
					<table-cell>
						<a v-if="mailto" :href="mailto">{{ email }}</a>
						<em v-else>Unknown</em>
					</table-cell>
				</table-row>
				<table-row>
					<th>Phone</th>
					<table-cell>
						<template v-if="phone">{{ phone }}</template>
						<em v-else>Unknown</em>
					</table-cell>
				</table-row>
				<table-row>
					<th>Campaign</th>
					<table-cell>
						<template v-if="campaignName">
							<core-button :is-link="true" :link-style="true" @click.prevent="goCampaign">{{
								campaignName
							}}</core-button>
						</template>
						<em v-else>Unknown</em>
					</table-cell>
				</table-row>
				<table-row>
					<th>Referring Page</th>
					<table-cell>
						<core-button
							v-if="pageURL"
							:link-style="true"
							target="_blank"
							:href="pageURL"
							class="omapi-link-inherit nohover"
						>
							{{ pageTitle }} <i class="fa fa-external-link" aria-hidden="true"></i>
						</core-button>
						<em v-else>Unknown</em>
					</table-cell>
				</table-row>
				<table-row>
					<th>Tags</th>
					<table-cell>
						<template v-if="tags.length">
							<span v-for="(tag, index) in tags" :key="tag.id">
								<core-button :is-link="true" :link-style="true" @click.prevent="goTag(tag.id)">{{
									tag.name
								}}</core-button>
								<span v-if="index + 1 < tags.length">, </span>
							</span>
						</template>
						<em v-else>Unknown</em>
					</table-cell>
				</table-row>
			</table-base>
			<div class="omapi-multi-column__secondary omapi-leadmodal__infoactions">
				<div class="omapi-leadmodal__meta">
					<div class="omapi-multi-column__title">Entry Details</div>
					<div class="omapi-multi-column__text omapi-calendar">Submitted: {{ created }}</div>
					<div class="omapi-multi-column__text omapi-map-point">
						<template v-if="ip">User IP: {{ ip }}</template>
						<em v-else>Unknown</em>
					</div>
				</div>
				<div class="omapi-leadmodal__actions">
					<div class="omapi-multi-column__title">Actions</div>
					<a v-if="mailto" :href="mailto" class="omapi-leadmodal__action-email">
						<i class="fa fa-envelope-o" alt="Mail"></i>Email Contact
					</a>
					<a class="omapi-leadmodal__action-delete" href="#" @click.prevent="maybeDeleteLead">
						<i class="fa fa-trash-o" alt="Trash"></i>Delete Entry
					</a>
				</div>
			</div>
		</modals-content>
	</core-modal>
</template>

<script>
import { lead } from '@/monsterleads/mixins/lead';

export default {
	mixins: [lead],
	props: {
		lead: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style lang="scss">
@import '../../../assets/scss/variables';
.omapi-screen .v--modal-overlay.omapi-leadmodal__wrapper {
	.v--modal {
		border-radius: 0;
	}
	header {
		border-radius: 0;
		background: $color_white;
		color: $color_black;
		border-bottom: solid 1px $color_grey-light;
		font-weight: $font_bold;
		line-height: 140%;
		padding: 20px 30px 19px;
		.close {
			color: $font_setting-color;
			svg {
				width: 13px !important;
				height: 13px;
			}
		}
	}
	.omapi-leadmodal {
		&__content {
			padding: 0;
			.omapi-table {
				border-collapse: collapse;
				font-size: 16px;
				th {
					padding: 22px 29px 22px 24px;
					color: $color_black;
					width: 1px;
					font-weight: 400;
				}
				.om-table-cell {
					width: 3px;
					color: $font_setting-color;
					i.fa {
						font-size: 14px;
						margin-left: 3px;
					}
				}
			}
		}

		&__infoactions {
			flex-basis: 275px;
			padding: 19px 30px 40px;
			border-left: solid 1px $color_grey-separator;
			.omapi-multi-column {
				&__title {
					font-size: 14px;
					font-weight: $font_bold;
					color: $color_black;
					margin-bottom: 8px;
				}
				&__text {
					font-size: 14px;
					font-weight: 400;
					color: $font_setting-color;
					line-height: 150%;
				}
			}
		}

		&__actions {
			font-size: 14px;
			line-height: 150%;
			i.fa {
				margin-right: 10px;
			}
		}

		&__action-email {
			color: $color_blue-primary;
			margin-bottom: 8px;
			display: block;
		}

		&__action-delete {
			color: $color_red;
			margin-bottom: 8px;
			cursor: pointer;
			&:hover {
				text-decoration: underline;
			}
		}
	}
}
</style>
